import classNames from 'classnames';
import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';
import styles from './PromoCard.module.scss';
import { PromoCardDesc } from './PromoCardDesc';
import { PromoCardLink } from './PromoCardLink';
import { PromoCardTitle } from './PromoCardTitle';

type PromoCardProps = {
	variant?: 'white' | 'green' | 'blue' | 'outline' | 'outline-dark' | 'dark';
	size?: 'sm' | 'lg';
	iconName?: IconProps['name'];
	iconColor?: IconProps['color'];
	disableLinkMask?: boolean;
	className?: string;
};

export const PromoCard: FC<PromoCardProps> = ({ variant = 'white', size, iconName, iconColor, disableLinkMask, className, children }) => {
	return (
		<div
			className={classNames(styles.promoCard, className, 'promoCard', {
				[styles[`promoCard--${variant}`]]: variant,
				[styles[`promoCard--${size}`]]: size,
				[styles[`promoCard--disable-link-mask`]]: disableLinkMask,
			})}
		>
			{iconName && (
				<span className={styles.promoCardIcon}>
					<Icon name={iconName} color={iconColor} size="xxl" />
				</span>
			)}

			<div className={classNames(styles.promoCardContent, 'mb-last-0')}>{children}</div>
		</div>
	);
};

export default Object.assign(PromoCard, {
	Desc: PromoCardDesc,
	Link: PromoCardLink,
	Title: PromoCardTitle,
});
